import ActionLog from '../pages/ActionLog/ActionLog'
import AnalyticsDashboard from '../pages/Analytics/AnalyticsDashboard'
import AnalyticsDeals from '../pages/Analytics/AnalyticsDeals'
import AnalyticsParts from '../pages/Analytics/AnalyticsParts'
import ArchivedPartList from '../pages/ArchivedParts/ArchivedPartList'
import Billing from '../pages/Billing/Billing'
import CarList from '../pages/CarList/CarList'
import ClientHistoryList from '../pages/ClientHistoryList/ClientHistoryList'
import ClientList from '../pages/ClientList/ClientList'
import DealList from '../pages/DealList/DealList'
import DealPage from '../pages/DealPage/DealPage'
import DocumentList from '../pages/DocumentList/DocumentList'
import InventoryPage from '../pages/Inventory/InventoryPage'
import Marketplaces from '../pages/Marketplaces/Marketplaces'
import NewCar from '../pages/NewCar/NewCar'
import NewPart from '../pages/NewPart/NewPart'
import CarDisassembly from '../pages/Onboarding/CarDisassembly/CarDisassembly'
import DownloadFromFile from '../pages/Onboarding/DownloadFromFile/DownloadFromFile'
import Onboarding from '../pages/Onboarding/Onboarding'
import PartDraftList from '../pages/PartDraftList/PartDraftList'
import PartList from '../pages/PartList/PartList'
import PayWall from '../pages/PayWall/PayWall'
import Sales from '../pages/Sales/Sales'
import Shop from '../pages/Shop/Shop'
import SoldPartList from '../pages/SoldParts/SoldPartList'
import WarehouseList from '../pages/WarehouseList/WarehouseList'

import { adminRouteAlias } from './adminRouteAlias'

const dealRoutes = [
    { path: adminRouteAlias.deals.list, element: <DealList /> },
    { path: adminRouteAlias.deals.new, element: <DealPage /> },
    { path: adminRouteAlias.deals.edit + '/:dealId', element: <DealPage /> },
]

export const adminRoutes = [
    { path: adminRouteAlias.cars.location, element: <CarList /> },
    { path: adminRouteAlias.cars.location + '/:carId', element: <CarList /> },
    { path: adminRouteAlias.parts.location, element: <PartList /> },
    { path: adminRouteAlias.soldParts.location, element: <SoldPartList /> },
    {
        path: adminRouteAlias.soldParts.location + '/:partId',
        element: <SoldPartList />,
    },
    {
        path: adminRouteAlias.archivedParts.location,
        element: <ArchivedPartList />,
    },
    {
        path: adminRouteAlias.archivedParts.location + '/:partId',
        element: <ArchivedPartList />,
    },
    {
        path: adminRouteAlias.parts.location + '/:partId',
        element: <PartList />,
    },
    { path: adminRouteAlias.sales.location, element: <Sales /> },
    { path: adminRouteAlias.warehouses.location, element: <WarehouseList /> },
    { path: adminRouteAlias.inventory.location, element: <InventoryPage /> },
    { path: adminRouteAlias.marketplaces.location, element: <Marketplaces /> },
    { path: adminRouteAlias.shop.location, element: <Shop /> },
    { path: adminRouteAlias.newCar.location, element: <NewCar /> },
    { path: adminRouteAlias.newPart.location, element: <NewPart /> },
    {
        path: adminRouteAlias.newPart.location + '/:carId',
        element: <NewPart />,
    },
    { path: adminRouteAlias.payWall.location, element: <PayWall /> },
    { path: adminRouteAlias.documents.location, element: <DocumentList /> },
    {
        path: adminRouteAlias.draftsOfParts.location,
        element: <PartDraftList />,
    },
    {
        path: adminRouteAlias.draftsOfParts.location + '/:partId',
        element: <PartDraftList />,
    },
    { path: adminRouteAlias.onboarding.location, element: <Onboarding /> },
    {
        path: adminRouteAlias.onboardingCarDisassembly.location,
        element: <CarDisassembly />,
    },
    {
        path: adminRouteAlias.onboardingDownloadFromFile.location,
        element: <DownloadFromFile />,
    },
    { path: adminRouteAlias.actionLog.location, element: <ActionLog /> },
    { path: adminRouteAlias.clients.location, element: <ClientList /> },
    { path: adminRouteAlias.clients.history, element: <ClientHistoryList /> },
    { path: adminRouteAlias.billing.location, element: <Billing /> },
    {
        path: adminRouteAlias.analytics.dashboard,
        element: <AnalyticsDashboard />,
    },
    { path: adminRouteAlias.analytics.deals, element: <AnalyticsDeals /> },
    { path: adminRouteAlias.analytics.parts, element: <AnalyticsParts /> },
    ...dealRoutes,
]
